import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MapInfoWindow, MapMarker } from '@angular/google-maps';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Component({
  selector: 'app-google-maps-picker',
  templateUrl: './google-maps-picker.component.html',
  styleUrls: ['./google-maps-picker.component.scss']
})
export class GoogleMapsPickerComponent implements OnInit {


    apiLoaded: Observable<boolean>;
    key_map = 'AIzaSyBaLzWbrRu2mktt_Ho3ejDUxRMss-51wBc';

    options: google.maps.MapOptions = {
        center: { lat: 40, lng: -20 },
        zoom: 4,
    }

    markerPosition: google.maps.LatLngLiteral = { lat: 40, lng: -20 };

    constructor(
        httpClient: HttpClient
    ) {
        // https://maps.google.com/maps/api/js?key=AIzaSyBaLzWbrRu2mktt_Ho3ejDUxRMss-51wBc&sensor=false&libraries=places
        // this.apiLoaded = httpClient.jsonp(`https://maps.google.com/maps/api/js??key=${this.key_map}&sensor=false&libraries=places`, 'callback').pipe(
        //     map(() => true),
        //     catchError(() => of(false)),
        // );
    }

    ngOnInit() {
    }

    click(event: google.maps.MapMouseEvent) {
        console.log(event)
    }

}